import { render, staticRenderFns } from "./WhActivityEdit.vue?vue&type=template&id=ddc3ab96&scoped=true&"
import script from "./WhActivityEdit.vue?vue&type=script&lang=js&"
export * from "./WhActivityEdit.vue?vue&type=script&lang=js&"
import style0 from "./WhActivityEdit.vue?vue&type=style&index=0&id=ddc3ab96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc3ab96",
  null
  
)

export default component.exports